"use client";

import useTranslate from "@app/_hooks/useTranslate";
import { useMarket } from "@context/marketContext";
import { useShippingCost } from "@pages/checkout-v2/Checkout.hooks";
import type { Cart as ICart, Payment } from "@server/gql/graphql";

import { cn } from "@/lib/utils";
import { formatPrice } from "@/utils/priceUtils";

type Props = {
  cart?: ICart;
  payments?: Payment[] | null | undefined;
  className?: string;
  showVAT?: boolean;
  showTotal?: boolean;
  showShipping?: boolean;
};

function NewProductSum(props: Props) {
  const {
    cart,
    className,
    showVAT = true,
    showTotal = true,
    showShipping = true,
  } = props;
  const t = useTranslate();
  const { locale } = useMarket().state.market;
  const { hasEstimatedShipping, shippingCost } = useShippingCost(showShipping);

  if (!cart) {
    return null;
  }

  return (
    <div className={cn("text-lg space-y-1", className)}>
      {showTotal && (
        <div className="flex justify-between child:leading-6">
          <p>{t("totalSumProducts")}</p>
          <p>{formatPrice(cart.totalGrossAmount, locale)}</p>
        </div>
      )}
      <div className="flex justify-between child:leading-6">
        <p className=" ">{t("amountToPay")}</p>
        <p className=" ">
          {formatPrice(
            hasEstimatedShipping
              ? cart.totalGrossAmount + shippingCost
              : cart.totalGrossAmount,
            locale,
          )}
        </p>
      </div>
      {showVAT && (
        <div className="flex justify-between child:leading-6">
          <p>{t("vat")}</p>
          <p>{formatPrice(cart.totalVat, locale)}</p>
        </div>
      )}
    </div>
  );
}

export default NewProductSum;
